document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".far-wishlist-button");
  const wishlist = JSON.parse(localStorage.getItem("shopify_wishlist") || "[]");

  buttons.forEach(btn => {
    const productId = String(btn.dataset.productId); // ensure it's a string

    // Pre-activate button if in localStorage
    if (wishlist.includes(productId)) {
      btn.classList.add("active");
    }

    btn.addEventListener("click", () => {
      const index = wishlist.indexOf(productId);

      if (index === -1) {
        wishlist.push(productId);
        btn.classList.add("active");
      } else {
        wishlist.splice(index, 1);
        btn.classList.remove("active");
      }

      localStorage.setItem("shopify_wishlist", JSON.stringify(wishlist));
    });
  });

  const container = document.getElementById("wishlist-products");
  const emptyMessage = document.getElementById("wishlist-empty");
  
  if (!wishlist.length) {
  emptyMessage.style.display = "block";
  return;
  }
  
  // wishlist.forEach(productId => {
  // // Build the product form dynamically
  // fetch(`/products/${productId}?view=wishlist-card`)
  //   .then(res => res.text())
  //   .then(html => {
  //     const div = document.createElement("div");
  //     div.innerHTML = html;
  //     container.appendChild(div.firstElementChild);
  //   });
  // });
  
});
